import { getDecimal, validateEmail } from "../global/utils";

export const feeFromName = (fees, name) => {
    if (fees && name) {
        const selectedFees = fees.filter(f => f.name === name);
        if (selectedFees) return selectedFees[0];
    }
    return null;
}

export const getFeeTotal = (selectedFees, selectedOption) => {
    let total = 0;
    if (selectedFees) {
        selectedFees.forEach(f => total += f.amount)
    }
    if (selectedOption && selectedOption.amount > 0) {
        total += selectedOption.amount;
    }
    total = parseFloat(getDecimal(total, false));
    return total;
}

export const validateFeeInfo = (selectedFees, selectedOption, form, court) => {
    let errors = '';
    const totalAmt = getFeeTotal(selectedFees, selectedOption);
    if (!selectedFees || selectedFees.length < 1) {
        errors = 'You must select at least one fee to pay';
    } else if (totalAmt <= 0) {
        errors = 'You must select items to pay with a value greater than zero';
    } else if (court.maxTransactionLimit && court.maxTransactionLimit > 0 && totalAmt > court.maxTransactionLimit) {
        errors = 'The total amount of the selected fees exceeds the maximum payment amount allowed by ' + court.courtName;
    }
    if (!form.payorName) errors += `${errors.length > 0 ? '; ' : ''}Your name is required`;
    if (!form.address) errors += `${errors.length > 0 ? '; ' : ''}Billing address is required`;
    if (!form.city) errors += `${errors.length > 0 ? '; ' : ''}Mailing city is required`;
    if (!form.state) errors += `${errors.length > 0 ? '; ' : ''}Mailing state is required`;
    if (!form.zip) errors += `${errors.length > 0 ? '; ' : ''}Billing zip code is required`;
    if (form.email && !validateEmail(form.email)) errors += `${errors.length > 0 ? '; ' : ''}Email address is invalid`;
    if (!form.email && !form.phone) errors += `${errors.length > 0 ? '; ' : ''}You must enter either an email address or phone number so we can contact you if there are questions about your request`;
    return errors;
}

export const getPaymentRequest = (courtId, selectedFees, selectedOption, form, feeTotal, processingFee) => {
    const fees = [...selectedFees];

    if (selectedOption) {
        fees.push({
            cmsId: selectedOption.cmsId,
            name: selectedOption.name,
            amount: selectedOption.amount,
            quantity: 1,
            itemAmount: selectedOption.amount,
            deliveryMethod: true,
            comments: selectedOption.description
        });
    }
    return {
        courtId: courtId,
        paymentDescription: getFeesPaymentDescription(selectedFees),
        processingType: 'miscFees',
        partyName: form.partyName ? form.partyName : form.payorName,
        payorName: form.payorName,
        payorAddress: form.address,
        payorCity: form.city,
        payorState: form.state,
        billingZip: form.zip,
        email: form.email,
        phone: form.phone,
        totalAmount: parseFloat(getDecimal(feeTotal + processingFee, false)),
        courtAmount: feeTotal,
        feeAmount: processingFee,
        miscellaneousFees: fees
    };
}

export const getFeesPaymentDescription = (selectedFees) => {
    const fees = selectedFees.filter(f => !f.deliveryMethod);
    return `Miscellaneous fees: ${fees[0].name.substring(0, 25)}`;
}
